<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M12.923 2.666c-.51 0-.923.448-.923 1s.413 1 .923 1h2.154v.701C8.88 5.838 4 11.015 4 17.332c0 6.627 5.373 12 12 12s12-5.373 12-12c0-3.378-1.395-6.43-3.641-8.61l1.014-1.015a1 1 0 10-1.414-1.414l-1.154 1.154a11.933 11.933 0 00-5.882-2.08v-.701h2.154c.51 0 .923-.448.923-1s-.413-1-.923-1h-6.154zm4.077 9a1 1 0 10-2 0v5.882a1 1 0 00.223.63l3.333 4.117a1 1 0 101.555-1.258L17 17.194v-5.528z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsStopwatchFilled'
}
</script>
